import React from 'react';
import { Box, Fade } from '@mui/material';
import { OverlayItem, SegmentItem } from '@/redux/slices/packagingSlice.types';
import { clearActiveHover, setActiveHover } from '@/redux/slices/packagingSlice';
import { useAppDispatch } from '@/redux/hooks';
import styled from '@emotion/styled';

interface Props {
  show: boolean;
  position: number;
  width: number;
  horizontalLine?: boolean;
  items: (OverlayItem | SegmentItem)[];
}

const GroupMarker: React.FC<Props> = ({ show, position, width, horizontalLine = false, items }) => {
  const dispatch = useAppDispatch();

  const handlePointerOver = () => {
    dispatch(setActiveHover(items));
  };

  const handlePointerOut = () => {
    dispatch(clearActiveHover());
  };

  return (
    <Fade in={show} timeout={300}>
      <Container sx={{ left: `${position}px`, width: `${width}px` }} horizontalLine={horizontalLine}>
        <Marker onPointerOver={handlePointerOver} onPointerOut={handlePointerOut}>
          {items.length}
          <Line />
        </Marker>
      </Container>
    </Fade>
  );
};

export default GroupMarker;

const BACKGROUND_COLOR = 'rgba(0, 0, 0, 0.8)';

const Container = styled(Box, { shouldForwardProp: (prop) => !['horizontalLine'].includes(prop) })<{ horizontalLine: boolean }>`
  position: absolute;
  top: 0;
  z-index: 1;
  height: 1px;
  ${({ horizontalLine }) => (horizontalLine ? `background-color: ${BACKGROUND_COLOR};` : '')}
`;

const Marker = styled(Box)`
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  padding: ${({ theme }) => theme.spacing(0.125, 0.75)};
  border-radius: ${({ theme }) => `${theme.shape.borderRadius}px`};
  background-color: ${BACKGROUND_COLOR};
  color: #ffffff;
  font-size: 10px;
`;

const Line = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 8px;
  background-color: ${BACKGROUND_COLOR};
  border-bottom-left-radius: 1px;
  border-bottom-right-radius: 1px;
`;
